import { breakpoints } from "@brightagency/headstart-common";
import { Link as RouterLink } from "react-router-dom";
import styled from "styled-components";
import { colors } from "../../../utils/colors";
import { SectionTitle } from "../../atoms/SectionTitle";

export const Title = styled(SectionTitle)`
    margin-bottom: 30px;
`;

export const Link = styled(RouterLink)`
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 16px 0 25px;
    text-decoration: none;
    color: ${colors.brandMid};
    border-bottom: 1px solid ${colors.brandXLight};
    font-weight: 500;

    &:hover {
        text-decoration: underline;
    }
    ${breakpoints.large} {
        padding: 0 0 25px;
    }
`;

export const Outer = styled.div`
    padding: 50px 0;    
`;